jQuery(function ($) {
	$(".haus-language-switcher-active-language a").on("click", function (event) {
		event.preventDefault();
		$(this)
			.closest(".haus-language-switcher")
			.find(".haus-language-switcher-languages")
			.slideToggle();
	});
});
